import {CheckoutOptionItem, optionItemSelected} from "../../redux/checkout/checkoutSlice";
import React from "react";
import Skeleton from "react-loading-skeleton";
import {RadioEmptyIcon, RadioFilledIcon} from "../icons";
import {Body, LocalizedTextLabel, Paragraph} from "../text";
import {useTranslation} from "next-i18next";
import {useAppDispatch} from "../../app/hooks";

interface CheckoutOptionItemViewProps {
  item: CheckoutOptionItem
  isLoading: boolean
}

export const CheckoutOptionItemView: React.FC<CheckoutOptionItemViewProps> = ({ item, isLoading }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  return <div
    className={`flex flex-row items-center space-x-4 lg:space-x-6 py-5 cursor-pointer border-b last:border-0 border-fg-gray-surface`}
    onClick={() => {
      dispatch(optionItemSelected(item))
    }}
  >
    <div className="flex-shrink-0">
      {
        (() => {
          if (isLoading) {
            return <Skeleton className="!rounded-full !h-7 !w-7 !mx-1.5" />
          } else if (item.isSelected) {
            return <RadioFilledIcon className="text-fg-primary h-6 w-6 mx-2" />
          } else {
            return <RadioEmptyIcon className="text-fg-gray-light h-6 w-6 mx-2" />
          }
        })()
      }
    </div>
    <div className="flex-grow">
      <Body className={`${item.subtitle ? 'mb-1' : ''}`}>
        {isLoading ? <Skeleton className="!w-3/4"/> : <LocalizedTextLabel t={t} text={item.title}/>}
      </Body>
      <Paragraph className={`${item.subtitle ? 'block' : 'hidden'} text-fg-gray-dark`}>
        {isLoading ? <Skeleton className="!w-1/3"/> : <LocalizedTextLabel t={t} text={item.subtitle}/>}
      </Paragraph>
    </div>
  </div>
}